import { useLanguage } from "../context/LanguageContext";
import { LANGUAGES } from "../i18n/translations";

export function LanguageSwitcher() {
  const { lang, setLang } = useLanguage();
  return (
    <div
      className="inline-flex items-center rounded-full border border-[#1A1F1C]/12 bg-white/70 p-0.5"
      role="group"
      aria-label="Language"
      data-testid="language-switcher"
    >
      {LANGUAGES.map((l) => {
        const active = l.code === lang;
        return (
          <button
            key={l.code}
            type="button"
            onClick={() => setLang(l.code)}
            aria-pressed={active}
            data-testid={`lang-switch-${l.code}`}
            className={`font-mono-label text-[11px] px-3 py-1.5 rounded-full transition-colors duration-200 ${
              active
                ? "bg-[#1E3A2B] text-[#FBFBF9]"
                : "text-[#525B56] hover:text-[#1A1F1C]"
            }`}
          >
            {l.short}
          </button>
        );
      })}
    </div>
  );
}
